import type { CellValue,RenderParam } from 'ksnm-common-ui/lib/Table2/Table.interface';

export const numberWithSpaces = (x: string | number | undefined): string | undefined =>
  x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export const moneyRender = ({ value }: RenderParam): CellValue => {
  if (typeof value === 'number') {
    return value.toLocaleString('ru-Ru', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
  }
  const val = Number(value);
  if (!Number.isNaN(val)) {
    if (val === 0) {
      return null;
    }
    return val.toLocaleString('ru-Ru', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
  }
  return value;
};

export const removeAddZerosAtEnd = (inputString = '', scale = 2): string => {
  if (!inputString || scale < 0) return inputString;

  const hasDecimal = inputString.includes('.');
  const [integer, float] = hasDecimal ? inputString.split('.') : [inputString, ''];

  if (scale > float.length) {
    const zerosWithFloat = `${float}${Array.from({ length: scale - float.length }, () => 0).join('')}`;
    const scaleNumberZeros = Array.from({ length: scale }, () => 0).join('');

    return float.length && float.length !== scale ? `${integer}.${zerosWithFloat}` : `${integer}.${scaleNumberZeros}`;
  } else if (scale < float.length) {
    return float.length && float[0] !== '0' ? `${integer}.${float.replace(/0+$/, '')}` : integer;
  }
  return inputString;
};

export const sortByLocaleCompare = <T>(data: T[], key: string): T[] =>
  data.sort((a, b) => {
    if (!a[key] || !b[key]) return 0;

    return a[key]?.localeCompare(b[key], undefined, {
      numeric: true,
      sensitivity: 'base',
    });
  });
